/** V2 login statusCode: 6 = OTP, 1 = password expiry warning + OTP, 2 = password expired, 4 = no MFA. */
export const V2_LOGIN_STATUS_OTP_REQUIRED = 6;
export const V2_LOGIN_STATUS_PASSWORD_EXPIRY_WARNING = 1;
export const V2_LOGIN_STATUS_PASSWORD_EXPIRED = 2;
export const V2_LOGIN_STATUS_NO_MFA = 4;

const getLoginResponseData = (response) => response?.data ?? response;

export const isV2LoginSuccessful = (response) => {
  const data = getLoginResponseData(response);
  return data?.successful === true || data?.success === true;
};

export const getV2LoginStatusCode = (response) => {
  const code = getLoginResponseData(response)?.statusCode;
  return code == null ? null : Number(code);
};

/** Resolve authId from V2 service response (API field is usually authID). */
export const extractOtpAuthId = (response) => {
  const data = getLoginResponseData(response);
  const authId =
    data?.authID
    ?? data?.authId
    ?? data?.data?.authID
    ?? data?.data?.authId
    ?? null;
  if (authId == null || authId === '') return null;
  const trimmed = String(authId).trim();
  return trimmed || null;
};

/** Change password: successful + statusCode 2. */
export const isV2LoginPasswordExpired = (response) =>
  isV2LoginSuccessful(response)
  && getV2LoginStatusCode(response) === V2_LOGIN_STATUS_PASSWORD_EXPIRED;

/** Resolve userId from V2 auth/login response. */
export const extractUserIdFromLoginResponse = (response) => {
  const data = getLoginResponseData(response);
  const userId = data?.userId ?? data?.userID ?? null;
  if (userId == null || userId === '') return null;
  const trimmed = String(userId).trim();
  return trimmed || null;
};

/** Password expiry warning + OTP: successful + statusCode 6 + authId. */
export const isV2LoginPasswordExpiryWarning = (response) =>
  isV2LoginSuccessful(response)
  && getV2LoginStatusCode(response) === V2_LOGIN_STATUS_PASSWORD_EXPIRY_WARNING
  && Boolean(extractOtpAuthId(response));

/** OTP screen: successful + statusCode 6 + authId present. */
export const requiresOtpFromLoginResponse = (response) =>
  isV2LoginSuccessful(response)
  && getV2LoginStatusCode(response) === V2_LOGIN_STATUS_OTP_REQUIRED
  && Boolean(extractOtpAuthId(response));

/** Portals: successful + statusCode 4 (V2 response now carries accessToken/refreshToken directly). */
export const isV2LoginNoMfa = (response) =>
  isV2LoginSuccessful(response)
  && getV2LoginStatusCode(response) === V2_LOGIN_STATUS_NO_MFA
  && Boolean(getLoginResponseData(response)?.accessToken);

export const isOtpValidateSuccess = (response) => {
  const data = getLoginResponseData(response);
  return data?.success === true || data?.successful === true;
};

export const extractSsoTokenFromOtpResponse = (response) => {
  const token = getLoginResponseData(response)?.ssoToken;
  if (token == null || token === '') return null;
  const trimmed = String(token).trim();
  return trimmed || null;
};
